<div class="eula-dialog">
  <div class="eula-dialog__header">
    <h2 mat-dialog-title class="eula-dialog__title">{{ title }}</h2>
  </div>

  <mat-dialog-content class="eula-dialog__content">
    <core-notification
      *ngIf="reviewOnly && acceptedAt"
      data-testid="eula-success-notification"
      class="eula-dialog__notification"
      label=""
      [message]="'EULA v' + eulaVersion + ' accepted on ' + (acceptedAt | date: 'MMMM d, y') + '.'"
      variant="inline"
      state="success"
      timer=""
      nocloseicon="True"
    >
    </core-notification>
    <div
      class="eula-dialog__eula-document"
      [class.eula-dialog__eula-document--with-toast]="reviewOnly && acceptedAt"
      #eulaContent
    >
      <div [innerHTML]="sanitizedContent"></div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="eula-dialog__actions">
    <div *ngIf="reviewOnly; else acceptActions">
      <button mat-raised-button class="eula-dialog__exit-btn" (click)="onCloseReview()">
        Close
      </button>
    </div>
    <ng-template #acceptActions>
      <button mat-raised-button class="eula-dialog__exit-btn" (click)="onExitApplication()">
        Exit application
      </button>
      <button
        mat-raised-button
        class="eula-dialog__accept-btn"
        [class.eula-dialog__accept-btn--disabled]="!isAcceptButtonEnabled"
        [disabled]="!isAcceptButtonEnabled"
        (click)="onAccept()"
        [attr.title]="!hasReadFullDocument ? 'Please read the complete document first' : ''"
      >
        Agree
      </button>
    </ng-template>
  </mat-dialog-actions>
</div>
